import React, { useState } from "react";
import { useSessionDataStore } from "../../../hooks/useSessionDataStore";
import { useGetStreamingUrl } from "../../../hooks/useGetStreamingUrl";
import log, { METRIC_NAME } from "../../../logging";
import { BrowserCreationErrorModal } from "../../BrowserCreationErrorModal/BrowserCreationErrorModal";
import { useAsyncEffect } from "use-async-effect";

// TODO  [LOWA-30534] From: https://tiny.amazon.com/aed5k04m
export const StreamingUrlSetup = () => {
    const streamingUrl = useSessionDataStore((store) => store.streamingUrl);
    const setStreamingUrl = useSessionDataStore(
        (store) => store.setStreamingUrl
    );
    const cookieSyncTarget = useSessionDataStore(
        (store) => store.cookieSyncTarget
    );

    // TODO [LOWA-30534] Migrate useGetStreamingUrl using react-query
    const getStreamingUrl = useGetStreamingUrl();
    const [streamingError, setStreamingError] = useState(null);

    useAsyncEffect(async () => {
        if (cookieSyncTarget == null) {
            return;
        }

        try {
            const streamingUrl = await getStreamingUrl(cookieSyncTarget);
            setStreamingUrl(streamingUrl);
        } catch (error) {
            setStreamingError(error);
        }
    }, [cookieSyncTarget]);

    if (streamingError != null) {
        log.publishHttpStatusMetric(
            METRIC_NAME.CREATE_REMOTE_BROWSER,
            streamingError?.$metadata?.httpStatusCode
        );
        return <BrowserCreationErrorModal error={streamingError} />;
    }

    return <></>;
};
